module.exports = __webpack_public_path__ + "img/search.82069e0f.png";